module.exports = __webpack_public_path__ + "media/images/azcentral-black-c789d1798af9940f888e75511f683692.png";